import { Typography } from '@mui/material';
import { useTheme } from '@mui/system';

export interface PieChartLabelProps {
  label: {
    subtitle: string;
    caption1?: string;
    caption2?: string;
  };
  viewBox?: { cx: number; cy: number };
}

export function PieChartLabel({
  label,
  viewBox: { cx, cy } = { cx: 0, cy: 0 },
}: PieChartLabelProps) {
  const theme = useTheme();

  return (
    <>
      <Typography
        component="text"
        variant="subtitle1"
        x={cx}
        y={cy}
        dy={-10}
        textAnchor="middle"
        fill={theme.palette.text.secondary}
      >
        {label.subtitle}
      </Typography>
      <Typography
        component="text"
        variant="caption"
        x={cx}
        y={cy}
        dy={10}
        textAnchor="middle"
        fill={theme.palette.text.secondary}
      >
        {label.caption1}
      </Typography>
      {!!label.caption2 ? (
        <Typography
          component="text"
          variant="caption"
          x={cx}
          y={cy}
          dy={25}
          textAnchor="middle"
          fill={theme.palette.text.secondary}
        >
          {label.caption2}
        </Typography>
      ) : null}
    </>
  );
}
